<template>
  <v-snackbar
    :timeout=10000
    :value="isVisible"
    bottom right
    multi-line
    @input="showNextSnackbar"
  >
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        :color="color"
        @click="executeAction"
        text
        v-bind="attrs"
      >
        {{ btnText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FhSnackbar',
  computed: {
    ...mapState('snackbar', [
      'isVisible',
      'message',
      'color',
      'actionText',
      'actionFunction',
    ]),
    btnText() {
      return this.actionText || 'Cerrar'
    },
  },
  methods: {
    ...mapActions('snackbar', [
      'showNextSnackbar'
    ]),
    executeAction() {
      if (!!this.actionFunction) {
        this.actionFunction()
      }
      this.showNextSnackbar()
    },
  }
}
</script>

<style scoped>

</style>
